<template>
  <div>
    <div>
      <div class="mb-4 is-flex is-align-items-center">
        <span class="has-text-weight-bold is-size-4">#{{ purchase.id }}</span>
        <span class="ml-5">
          <b-tag type="is-orange">{{
            $t(PURCHASE_STATUS.TOKEN[purchase.status])
          }}</b-tag></span
        >
      </div>

      <template v-if="loaded">
        <div class="columns">
          <div class="column is-two-thirds">
            <div class="entity-details-card">
              <h4 class="has-text-weight-bold">
                {{ $t("mp:purchase.main.title") }}
              </h4>
              <div class="entity-details-card-row pb-3">
                <div>
                  <p
                    class="is-size-7 is-uppercase mb-1 mt-2 has-text-grey-icon"
                  >
                    {{ $t("mp:purchase.main.basket_amount.label") }}
                  </p>
                  <span class="has-text-weight-medium"
                    >{{ purchase.totalAmount | monify }} Ft</span
                  >
                </div>
                <div>
                  <p
                    class="is-size-7 is-uppercase mb-1 mt-2 has-text-grey-icon"
                  >
                    {{ $t("mp:purchase.main.basket_count.label") }}
                  </p>
                  <span class="has-text-weight-medium"
                    >{{ purchase.itemCount }} db</span
                  >
                </div>
                <div>
                  <p
                    class="is-size-7 is-uppercase mb-1 mt-2 has-text-grey-icon"
                  >
                    {{ $t("mp:purchase.main.down_payment.label") }}
                  </p>
                  <span class="has-text-weight-medium"
                    ><span v-if="purchase.downPayment"
                      >{{ purchase.downPayment | monify }} Ft</span
                    ><span v-else>-</span></span
                  >
                </div>
                <div>
                  <p
                    class="is-size-7 is-uppercase mb-1 mt-2 has-text-grey-icon"
                  >
                    {{ $t("mp:purchase.main.loan_amount.label") }}
                  </p>
                  <span class="has-text-weight-medium"
                    >{{ purchase.loanAmount | monify }} Ft</span
                  >
                </div>
              </div>
            </div>
          </div>

          <div class="column">
            <div class="entity-details-card">
              <h4 class="has-text-weight-bold">
                {{ purchase.customerName }}
              </h4>

              <div class="entity-details-card-row pb-3">
                <div>
                  <p
                    class="is-size-7 is-uppercase mb-1 mt-2 has-text-grey-icon"
                  >
                    {{ $t("mp:purchase.main.customer_phone.label") }}
                  </p>
                  <span class="has-text-weight-medium">{{
                    purchase.customerPhone | phone
                  }}</span>
                </div>
                <div>
                  <p
                    class="is-size-7 is-uppercase mb-1 mt-2 has-text-grey-icon"
                  >
                    {{ $t("mp:purchase.main.customer_email.label") }}
                  </p>
                  <span class="has-text-weight-medium">{{
                    purchase.customerEmail
                  }}</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </template>

      <LoadingSkeleton v-else></LoadingSkeleton>
    </div>

    <div v-if="loaded" class="mt-6">
      <b-tabs v-model="activeTab" class="mb-0">
        <b-tab-item :label="$t('mp:purchase.tab.base_data')" />
      </b-tabs>

      <template>
        <template v-if="activeTab === TABS.BASE_DATE">
          <div class="ml-4">
            <div class="columns">
              <div class="column is-3">
                <div class="mb-4">
                  <p class="mb-1 has-text-grey-icon">
                    {{ $t("mp:purchase.base_date.last_name.label") }}
                  </p>
                  <span class="has-text-weight-medium">{{
                    purchase.customerName.split(" ")[0]
                  }}</span>
                </div>
              </div>

              <div class="column is-3">
                <div class="mb-4">
                  <p class="mb-1 has-text-grey-icon">
                    {{ $t("mp:purchase.base_date.first_name.label") }}
                  </p>
                  <span class="has-text-weight-medium">
                    {{ purchase.customerName.split(" ")[1] }}
                  </span>
                </div>
              </div>
            </div>

            <div class="columns">
              <div class="column is-3">
                <div class="mb-4">
                  <p class="mb-1 has-text-grey-icon">
                    {{ $t("mp:purchase.base_date.customer_phone.label") }}
                  </p>
                  <span class="has-text-weight-medium">
                    {{ purchase.customerPhone | phone }}
                  </span>
                </div>
              </div>
              <div class="column is-3">
                <div class="mb-4">
                  <p class="mb-1 has-text-grey-icon">
                    {{ $t("mp:purchase.base_date.customer_email.label") }}
                  </p>
                  <span class="has-text-weight-medium"
                    >{{ purchase.customerEmail }}
                  </span>
                </div>
              </div>
            </div>
          </div>
        </template>
      </template>
    </div>
  </div>
</template>

<script>
import { PURCHASE_STATUS } from "../utils/const";

const TABS = {
  BASE_DATE: 0,
};

export default {
  name: "Purchase",
  title: "mp:page.purchase.title",
  components: {
    LoadingSkeleton: () => import("@/components/LoadingSkeleton"),
  },
  props: {
    id: {
      type: [String, Number],
      required: true,
    },
  },
  data() {
    return {
      TABS,
      PURCHASE_STATUS,
      activeTab: TABS.BASE_DATE,
      loaded: false,
      purchase: {},
    };
  },
  computed: {},
  async created() {
    await this.fetch();
    this.loaded = true;
  },
  methods: {
    async fetch() {
      await this.$store.dispatch("purchase/fetch", this.id);
      this.purchase = this.$store.getters["purchase/get"](this.id);
    },
  },
};
</script>

<style scoped lang="scss"></style>
